module.exports = __webpack_public_path__ + "img/header-left.e2d8b7a1.png";